import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DeliveryMethodContinentRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return indexableFilters.length === 2
			&& indexableFilters.some((_) => _.type === ParameterType.CONTINENT)
			&& indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DELIVERY_METHOD_CONTINENT_ROUTE,
			params: {
				delivery_method: this.extractPath(filters.find((_) => _.type === ParameterType.DELIVERY_METHOD)),
				continent: this.extractPath(filters.find((_) => _.type === ParameterType.CONTINENT)),
			},
		};
	}
}
